import ReactRenderer from './modules/_react-renderer'
import AdForm from './react/AdForm'
import Activities from './react/activities/Activities'

(function(){
  ReactRenderer.registerComponent('AdForm', AdForm)
  ReactRenderer.registerComponent('Activities', Activities)
  ReactRenderer.render()
})()
